import store from "@/store";
import {
  CLEAR_ACCOUNT_ISLOADING,
  CLEAR_USERS_ISLOADING,
  CLEAR_VERIFICATIONS_ISLOADING,
  CLEAR_BANK_ACCOUNTS_ISLOADING,
  CLEAR_SUBSCRIPTIONS_ISLOADING,
} from "@/store/action_types";

export const resetLoaders = () => {
  store.dispatch(CLEAR_ACCOUNT_ISLOADING);
  store.dispatch(CLEAR_USERS_ISLOADING);
  store.dispatch(CLEAR_VERIFICATIONS_ISLOADING);
  store.dispatch(CLEAR_BANK_ACCOUNTS_ISLOADING);
  store.dispatch(CLEAR_SUBSCRIPTIONS_ISLOADING);
};
